import { render, staticRenderFns } from "./customerpushlog.vue?vue&type=template&id=85e4880c&"
import script from "./customerpushlog.vue?vue&type=script&lang=js&"
export * from "./customerpushlog.vue?vue&type=script&lang=js&"
import style0 from "./customerpushlog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports